export default {
  check_status: {
    verified: 'Bestätigt',
    pending: 'Ausstehend',
    failed: 'Fehlgeschlagen',
    not_applicable: 'Nicht erforderlich',
    required: 'Erforderlich',
  },
  records: {
    type: 'Typ',
    name: 'Name',
    value: 'Wert',
    status: 'Status',
    certificate: 'Zertifikat',
    certificate_hint: 'Wird automatisch ausgestellt, sobald die Einträge oben gefunden werden.',
    full_name: 'Vollständiger Name:',
  },
  check_hint: {
    found: 'Gefunden wurde stattdessen {{values}}. Ersetzen Sie den Eintrag durch den angezeigten Wert.',
    missing: 'Dieser Eintrag wurde nicht gefunden.',
    certificate:
      'Das Zertifikat konnte nicht ausgestellt werden. Korrigieren Sie die oben markierten Einträge und prüfen Sie erneut.',
    certificate_unknown:
      'Das Zertifikat konnte nicht ausgestellt werden. Prüfen Sie später erneut und wenden Sie sich an den Support, falls es so bleibt.',
    regressed: 'Dieser Eintrag war bereits bestätigt und wird nicht mehr gefunden.',
    technical: 'Technisches Detail: {{error}}',
    held_by_another_project:
      '{{name}} wird von einer anderen Website auf Vercel verwendet und kann Besucher daher nicht an den Shop unter www.{{name}} weiterleiten. Damit auch {{name}} den Shop öffnet, entfernen Sie die Domain zuerst von dieser anderen Website.',
    certificate_pending: {
      not_attached: 'In Bearbeitung: Die Domain wird bei uns eingerichtet.',
      awaiting_dns: 'In Bearbeitung: Das Zertifikat wird ausgestellt, sobald die Einträge oben gefunden werden.',
      awaiting_certificate:
        'In Bearbeitung: Die Einträge zeigen auf uns, und das Zertifikat wird ausgestellt. Das dauert meist ein paar Minuten.',
    },
    certificate_failed: {
      ownership_proof_required:
        '{{name}} ist auch mit einem anderen Vercel-Konto verbunden. Um nachzuweisen, dass die Domain Ihnen gehört, legen Sie zusätzlich die TXT-Einträge unten beim DNS-Anbieter an und prüfen Sie dann erneut.',
      held_by_another_project:
        'Eine andere Website auf Vercel verwendet {{name}} bereits. Entfernen Sie die Domain zuerst dort und prüfen Sie dann erneut — oder verwenden Sie eine andere Domain.',
      dns_correct_but_unconfigured:
        'Die Einträge oben sind korrekt, aber etwas anderes auf {{name}} verhindert das Zertifikat. Entfernen Sie alle AAAA-Einträge für diesen Namen, schalten Sie einen vorgeschalteten Proxy aus (etwa die orange Wolke bei Cloudflare) und stellen Sie sicher, dass kein CAA-Eintrag Let’s Encrypt ausschließt. Prüfen Sie dann erneut.',
      name_mismatch:
        '{{name}} antwortet mit einem Zertifikat für {{names}}. Stellen Sie sicher, dass die Einträge oben die einzigen für {{name}} sind; falls ja, wenden Sie sich an den Support.',
      name_mismatch_unnamed:
        '{{name}} antwortet mit einem Zertifikat für einen anderen Namen. Stellen Sie sicher, dass die Einträge oben die einzigen für {{name}} sind; falls ja, wenden Sie sich an den Support.',
      expired:
        'Das Zertifikat ist abgelaufen und wurde nicht erneuert. Wir wurden benachrichtigt und kümmern uns darum — Sie müssen vorerst nichts tun.',
      expiring:
        'Das Zertifikat läuft bald ab und wurde noch nicht erneuert. Wir kümmern uns darum — Sie müssen vorerst nichts tun.',
      attach_refused:
        'Unser Hosting-Anbieter hat {{name}} auf unserer Seite nicht hinzugefügt. Wir wurden benachrichtigt und prüfen das — beim DNS-Anbieter muss vorerst nichts geändert werden.',
    },
    certificate_overdue: {
      not_attached:
        'Die Domain konnte auch nach 48 Stunden nicht bei uns eingerichtet werden. Wenden Sie sich an den Support.',
      awaiting_dns:
        'Auch nach 48 Stunden wird noch auf die Einträge oben gewartet. Korrigieren Sie die oben markierten Einträge und prüfen Sie erneut.',
      awaiting_dns_records_verified:
        'Auch nach 48 Stunden noch nicht ausgestellt, obwohl die Einträge oben bestätigt sind. Wenden Sie sich an den Support.',
      awaiting_certificate:
        'Die Einträge zeigen auf uns, aber das Zertifikat wurde auch nach 48 Stunden noch nicht ausgestellt. Wenden Sie sich an den Support.',
    },
    certificate_dates: {
      valid_until: 'Gültig bis {{date}}.',
      expires_on: 'Läuft am {{date}} ab.',
      expired_on: 'Abgelaufen am {{date}}.',
    },
  },
};
